import React, { useEffect } from "react";
import logo from "../images/logo.png";
import { useState } from "react";
import { IoMailSharp } from "react-icons/io5";
import { FaPhone, FaFacebookF, FaInstagram } from "react-icons/fa";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { IoCloseOutline } from "react-icons/io5";
import "../styles/navbar.scss";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  useEffect(
    () => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }

      return () => {
        document.body.style.overflow = "auto";
      };
    },
    [isOpen]
  );

  return (
    <nav className="main-container nav">
      <a href="/">
        <img src={logo} alt="Logo" />
      </a>

      <button className="menu-button" onClick={toggleMenu}>
        {isOpen ? <IoCloseOutline /> : <HiOutlineMenuAlt4 />}{" "}
      </button>

      <ul className={isOpen ? "open" : ""}>
        <li>
          <a href="/">Početna</a>
        </li>
        <li>
          <a href="/o-nama">O Nama</a>
        </li>
        <li>
          <a href="/uniforme">Uniforme</a>
        </li>
        <li>
          <a href="/galerija">Galerija</a>
        </li>
        <li>
          <a href="/kontakt">Kontakt</a>
        </li>
      </ul>
      <div className="contact-nav">
        <a href="mailto:sladjanaijana16@gmail.com">
          <IoMailSharp />
        </a>
        <a href="tel:0631833253">
          <FaPhone />
        </a>
        <a target="__blank" href="https://www.facebook.com/unijanauniforme">
          <FaFacebookF />
        </a>
        <a target="__blank" href="https://www.instagram.com/unijanaclothing/">
          <FaInstagram />
        </a>
      </div>
    </nav>
  );
}
